import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";

export default class TurnaroundModel extends LabServiceModel {
  modelName() {
    return "turnaround";
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      sample_type_id: null,
      sample_type: null,
      name: null,
      description: null,
      surcharge: null,
      surcharge_type: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      sample_type_id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      surcharge: Number,
      surcharge_type: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, "laboratory");
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, "sample_type");
  }
}
